<template>
  <!--eslint-disable-->
  <v-card flat class="pa-3 mt-2">
    <v-form class="multi-col-validation">
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="12">
            <v-textarea
              outlined
              v-model="informationData.name"
              rows="3"
              label="Bio"
            ></v-textarea>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              outlined
              dense
              v-model="informationData['created_at']"
              label="Joined On"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              outlined
              dense
              v-model="informationData.name"
              label="Full Name"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              outlined
              dense
              v-model="informationData['employee']"
              label="Employee Number"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-select
              outlined
              dense
              v-model="informationData.status"
              label="Account Status"
              :items="['Active', 'Inactive', 'Suspended']"
            ></v-select>
          </v-col>

          <v-col cols="12" md="6">
            <v-select
              outlined
              dense
              multiple
              chips
              small-chips
              label="Languages"
              :items="['English', 'Spanish', 'French', 'German']"
            ></v-select>
          </v-col>

          <v-col cols="12" md="6">
            <p class="text--primary mt-n3 mb-2">Gender</p>
            <v-radio-group
              row
              class="mt-0"
              hide-details
              v-model="informationData['gender']"
            >
              <v-radio
                v-for="gen in gender"
                :key="gen.name"
                :label="gen.name"
                :value="gen.name"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-btn class="me-3 mt-3 profile-btn"> Save changes </v-btn>
        <v-btn
          outlined
          class="mt-3"
          color="secondary"
          type="reset"
          @click.prevent="resetForm"
        >
          Cancel
        </v-btn>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import SettingMixin from "../../SettingMixin";

export default {
  name: "AccountSettingsInfo",
  mixins: [SettingMixin],
  props: {
    informationData: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    gender: [
      {
        name: "Male",
        value: 1,
      },
      {
        name: "Female",
        value: 2,
      },
      {
        name: "Other",
        value: 3,
      },
    ],
  }),
};
</script>
